import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faLock, faUser } from '@fortawesome/free-solid-svg-icons';

const LoginForm = ({ error, handleSubmit, pristine, submitting, t }) => {

	return (
		<form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='username' component={Input} type='text' placeholder={t('Login_Username')} icon={faUser} validate={validators.required} className='form-control redux-field' />
			<Field name='password' component={Input} type='password' placeholder={t('Login_Password')} icon={faLock} validate={[validators.required]} />
			<Link to={`/forgottenPassword`} className='forgot'>{t('Login_ForgottenPassword')}</Link>
			<div className='form-actions'>
				<Button type='submit' disabled={pristine || submitting} className='btn-bricky pull-right'>
					{t('Login_Login')} <FontAwesomeIcon icon={faArrowCircleRight} />
				</Button>
			</div>
		</form>
	);
};

LoginForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'login' })(withTranslation()(LoginForm));